import {Component, Directive, OnDestroy, OnInit} from "@angular/core";
import {Observable, Subject, Subscription} from "rxjs";

@Directive() // ✅ required to satisfy Angular compiler
export class Base implements OnDestroy {

    subs = new Subscription();

    ngOnDestroy() {
        this.subs.unsubscribe(); // unsubscribes all
    }

}